import {OnboardingInterface} from "../store";
import {config} from "../config";
import {OnboardingTypes, SelectCommunityRowAction} from "../actions/onboarding.action";
import {
  HIDE_ONBOARDING_LOADING,
  RECEIVE_ONBOARDING, RECEIVE_ONBOARDING_INITIAL_DATA, SELECT_COMMUNITY_ID,
  SELECT_ONBOARDING,
  SHOW_ONBOARDING_LOADING,
  UPDATE_ONBOARDING_FILTER
} from "../constants/onboardingConstants";
import {CommunityInterface} from "../interfaces/community.interface";


export const onboardingReducer = (state: OnboardingInterface = getOnboardingInitialState(), action : OnboardingTypes): any => {
  switch (action.type) {
    case UPDATE_ONBOARDING_FILTER:
      return {
        ...state,
        filters: {
          ...action.payload
        }
      }
    case RECEIVE_ONBOARDING:
      return {
        ...state,
        initialized: true,
        dataSource: {
          ...state.dataSource,
          ...action.payload
        }
      }
    case RECEIVE_ONBOARDING_INITIAL_DATA:
      return {
        ...state,
        initialized: true,
        catalog: {
          managementCompanies: action.managementCompanies
        }
      }
    case SELECT_ONBOARDING:
      return {
        ...state,
        onboardingSelectedId: action.id
      }
    case SHOW_ONBOARDING_LOADING:
      return {
        ...state,
        loading: true
      }
    case HIDE_ONBOARDING_LOADING:
      return {
        ...state,
        loading: false
      }
      case SELECT_COMMUNITY_ID:
        const payload = action as SelectCommunityRowAction;
        if (payload.communityId == 0) {
          return {
            ...state,
            allSelected: payload.checked,
            communitySelectedIds: payload.checked  ? [...getCommunityIds(state.dataSource.items as CommunityInterface[])] : [],
            dataSource: {
              ...state.dataSource,
              items: state.dataSource.items.map((item) => {
                const community = item as CommunityInterface;
                if (community.id > 0 && community.onboardingStatus === 'Sent to Underwriting (Pending)') {
                  community.isSelected = payload.checked;
                }
                return item;
              })
            }
          }
        }
        return {
          ...state,
          allSelected: false,
          communitySelectedIds: payload.checked && state.communitySelectedIds ? [...state.communitySelectedIds, payload.communityId] :
            (state.communitySelectedIds ? state.communitySelectedIds.filter((id) => id != payload.communityId) : [payload.communityId]),
          dataSource: {
            ...state.dataSource,
            items: state.dataSource.items.map((item) => {
              const community = item as CommunityInterface;
              if (community.id == payload.communityId) {
                community.isSelected = payload.checked;
              }
              return item;
            })
          }
        }
    default:
      return state;
  }
}

const getOnboardingInitialState = (): OnboardingInterface => {
  return {
    filters: {
      pageNumber: 1,
      pageSize: config.onboardingPageSize
    },
    initialized: false,
    catalog: {},
    loading: false,
    dataSource: {limit: config.onboardingPageSize, offset: 0, itemCount: 0, items: []},
    onboardingSelectedId: undefined,
    allSelected: false,
    communitySelectedIds: []
  }
}

const getCommunityIds = (communities: CommunityInterface[]): number[] => {
  return communities.filter((community) => community.id > 0 && community.onboardingStatus === 'Sent to Underwriting (Pending)')
    .map((community) => community.id);
}
